import React from 'react';

import whyDownload from '@assets/images/why-download.png';
import { APIcon } from '@components/atoms/APIcon';
import { APImage } from '@components/atoms/APImage';
import { Typography } from '@components/atoms/Typography';

export const BenefitsSection: React.FC = () => {
  return (
    <section className="relative isolate rounded-xl w-full max-w-4xl p-6 flex flex-col lg:flex-row overflow-hidden bg-cyan-100">
      <div className="z-10">
        <Typography
          textKey="AstroPayDownload.benefitsTitle"
          variant="h3"
          weight={600}
          className="mb-2 text-[20px]"
        />
        <ul>
          <li>
            <APIcon img="globe" alt="Global icon" size={20} />
            <Typography
              textKey="AstroPayDownload.benefit1"
              weight={600}
              className="text-[12px]"
              variant="span"
            />
          </li>
          <li>
            <APIcon img="cashbackPromos" alt="Cashback icon" size={20} />
            <Typography
              textKey="AstroPayDownload.benefit2"
              weight={600}
              className="text-[12px]"
              variant="span"
            />
          </li>
          <li>
            <APIcon img="lockLine" alt="Safety icon" size={20} />
            <Typography
              textKey="AstroPayDownload.benefit3"
              weight={600}
              className="text-[12px]"
              variant="span"
            />
          </li>
        </ul>
      </div>
      <APImage
        img={whyDownload}
        width={250}
        height={250}
        className="absolute -right-20 top-10 -translate-y-1/2 -z-10 pointer-events-none object-contain hidden sm:block"
        loadingStrategy="eager"
      />
    </section>
  );
};
